import {
  ME_GET_REQUEST,
  ME_GET_RECEIVE,
  ME_PATCH_REQUEST,
  ME_PATCH_RECEIVE,
  SEND_MESSAGE_RECEIVE,
  SEND_MESSAGE_REQUEST,
  LANGUAGE_DETECTION_RECEIVE,
  LANGUAGE_DETECTION_REQUEST,
  TRANSLATE_RECEIVE,
  TRANSLATE_REQUEST,
  SEND_MESSAGE_GROUPS_REQUEST,
  SEND_MESSAGE_GROUPS_RECEIVE,
  GROUP_MESSAGES_REQUEST,
  GROUP_MESSAGES_RECEIVE,
  GET_FILTERS_FOR_GROUPS_RECEIVE,
  GET_FILTERS_FOR_GROUPS_REQUEST,
} from '../actions/communication';
import { API_FAILURE } from '../actions';
import { HIDE_MODAL, RESET_ERROR_MESSAGE, SHOW_MODAL } from '../actions/internal';

const defaultStateArray = {
  loading: false,
  data: [],
  error: null,
}

const defaultStateObject = {
  loading: false,
  data: {},
  error: null,
}

export function me(state = defaultStateObject, action) {
  switch (action.type) {
    case ME_GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ME_GET_RECEIVE:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ME_PATCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ME_PATCH_RECEIVE:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case API_FAILURE:
      if (action.meta && action.meta.type === ME_GET_REQUEST) {
        return {
          ...state,
          loading: false,
          error: action.error || 'Error fetching personal information',
        };
      } else if (action.meta && action.type === ME_PATCH_REQUEST) {
        return {
          ...state,
          loading: false,
          error: action.error || 'Error updating personal information',
        };
      }
      return state;
    default:
      return state;
  }
}

export function filters(state = {}, action) {
  switch (action.type) {
    case GET_FILTERS_FOR_GROUPS_REQUEST:
      return {
        ...state,
        filtersForGroups: {
          isLoading: true,
          loaded: false,
        }
      };
    case GET_FILTERS_FOR_GROUPS_RECEIVE:
      return {
        ...state,
        filtersForGroups: {
          filters: action.payload,
          isLoading: false,
          loaded: true,
        },
      };
    default:
      return state;
  }
}

export function communication(state = {}, action) {
  switch (action.type) {
    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        isSending: true,
        sendingComplete: false,
      };
    case SEND_MESSAGE_RECEIVE:
      return {
        ...state,
        isSending: false,
        sendingComplete: true,
      };
    case SEND_MESSAGE_GROUPS_REQUEST:
      return {
        ...state,
        isSending: true,
        sendingComplete: false,
      };
    case SEND_MESSAGE_GROUPS_RECEIVE:
      return {
        ...state,
        isSending: false,
        sendingComplete: true,
      };
    case SHOW_MODAL:
      if (action.modalType === 'COMMUNICATION_NEW_MESSAGE') {
        return {
          ...state,
          isSending: false,
          sendingComplete: false,
        };
      }
      return state;
    case HIDE_MODAL:
      return {
        ...state,
        isSending: false,
        sendingComplete: false,
        isDetecting: false,
        isTranslating: false,
        translation: {},
      };
    case LANGUAGE_DETECTION_REQUEST:
      return {
        ...state,
        isDetecting: true,
      };
    case LANGUAGE_DETECTION_RECEIVE:
      return {
        ...state,
        isDetecting: false,
        translation: {
          ...state.translation,
          detected: action.payload,
        },
      };
    case TRANSLATE_REQUEST:
      return {
        ...state,
        isTranslating: true,
      };
    case TRANSLATE_RECEIVE:
      return {
        ...state,
        isTranslating: false,
        translation: {
          ...state.translation,
          translated: action.payload,
        },
      };
    case RESET_ERROR_MESSAGE:
      return {
        ...state,
        isSending: false,
        isDetecting: false,
        isTranslating: false,
      };
    case API_FAILURE:
      const originalType = action.meta?.type;
      if (originalType === LANGUAGE_DETECTION_REQUEST) {
        return {
          ...state,
          isDetecting: false,
          error: `Error detecting language: ${action.payload}`
        };
      } else if (originalType === TRANSLATE_REQUEST) {
        return {
          ...state,
          isTranslating: false,
          error: `Error translating: ${action.payload}`
        };
      }
      return state;
    default:
      return state;
  }
}

export function groupMessages(state = defaultStateArray, action) {
  switch (action.type) {
    case GROUP_MESSAGES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GROUP_MESSAGES_RECEIVE:
      return {
        ...state,
        data: action.payload.page === 1
          ? action.payload.messages
          : state.data.concat(action.payload.messages),
        loading: false,
        page: action.payload.page,
        totalPages: action.payload.totalPages,
      };
    default:
      return state;
  }
}
